import { useState, type ReactNode } from 'react';
import { ChevronRight } from 'lucide-react';

/** A titled section of the inspector that opens on a click: "How this was made", "Source". */
export function Disclosure({ title, children }: { title: string; children: ReactNode }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`disclosure ${open ? 'open' : ''}`}>
      <button type="button" className="disclosure-head" aria-expanded={open} onClick={() => setOpen(!open)}>
        <ChevronRight size={13} strokeWidth={1.5} />
        <span>{title}</span>
      </button>
      {open ? <div className="disclosure-body">{children}</div> : null}
    </div>
  );
}
